import React from "react";
import InView from "react-intersection-observer";
import Loader from "./loader";

type OnViewChange = (inView: boolean, observerEntry) => void;

function InfiniteLoaderViewElement() {
	return <div className="loaderNotInViewport" />;
}

const InfiniteLoader = ({ onViewChange }: { onViewChange: OnViewChange }) => {
	return (
		<InView onChange={onViewChange}>
			{({ inView, ref }) => <div ref={ref}>{inView ? <Loader /> : <InfiniteLoaderViewElement />}</div>}
		</InView>
	);
};

export const InvisibleInfiniteLoader = ({
	onViewChange,
	children,
	loading = false,
	treshold = 0,
	rootMargin = "0px 0px 0px 0px",
}: {
	onViewChange: OnViewChange;
	loading?: boolean;
	children?;
	treshold?: number | number[];
	rootMargin?: string;
}) => {
	return (
		<InView onChange={onViewChange} threshold={treshold} rootMargin={rootMargin}>
			{({ inView, ref }) => (
				<div ref={ref}>
					{loading ? <Loader /> : <InfiniteLoaderViewElement />}
					{children}
				</div>
			)}
		</InView>
	);
};

export default InfiniteLoader;
